import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cozy%20modern%20living%20room%20with%20soft%20natural%20morning%20light%20streaming%20through%20large%20windows%2C%20comfortable%20neutral%20toned%20sofa%20with%20plush%20throw%20pillows%20and%20folded%20blanket%2C%20wooden%20coffee%20table%20with%20a%20steaming%20mug%20and%20open%20book%2C%20potted%20plants%20adding%20life%20and%20greenery%2C%20calm%20peaceful%20atmosphere%2C%20hygge%20inspired%20interior%20design%2C%20cream%20beige%20terracotta%20and%20sage%20green%20color%20palette%2C%20soft%20diffused%20lighting%20creating%20gentle%20shadows%2C%20home%20comfort%20and%20wellness%20aesthetic%2C%20no%20people%20in%20frame&width=1800&height=1200&seq=hero-home-v2&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/50" />
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 py-32 md:py-40">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-14 lg:gap-24">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/25 mb-8">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-background-50/90 text-sm font-medium">
                Free for amputees — always
              </span>
            </div>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
              From intake to insurance
              <br />
              to walking comfortably —
              <br />
              <span className="italic font-serif">all from home. Free.</span>
            </h1>

            <p className="mt-6 text-base md:text-lg text-background-50/85 max-w-lg mx-auto lg:mx-0 leading-relaxed">
              Whether you need a prosthetist or already have one you love, we
              handle the paperwork, pull your coverage, arrange financing, and
              connect your whole care team — so you can focus on what matters:
              walking again.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4">
              <Link
                to="/intake"
                className="bg-primary-500 text-background-50 px-10 py-4 rounded-full text-lg font-semibold hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                Start your journey now
                <span className="w-5 h-5 inline-flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
              <a
                href="#how-it-works"
                className="inline-flex items-center gap-2 text-background-50/80 hover:text-background-50 border border-background-50/30 hover:border-background-50/50 px-7 py-3.5 rounded-full text-[15px] font-medium transition-all whitespace-nowrap cursor-pointer"
              >
                See how it works
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-down-line text-sm"></i>
                </span>
              </a>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-4 text-background-50/70 text-sm">
              <div className="flex items-center gap-1.5">
                <span className="w-5 h-5 flex items-center justify-center text-accent-400">
                  <i className="ri-checkbox-circle-line"></i>
                </span>
                <span>Always free for amputees</span>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="w-5 h-5 flex items-center justify-center text-accent-400">
                  <i className="ri-brain-line"></i>
                </span>
                <span>We do the paperwork</span>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="w-5 h-5 flex items-center justify-center text-accent-400">
                  <i className="ri-hand-heart-line"></i>
                </span>
                <span>Works with any clinic or finds you one</span>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-6 bg-accent-400/15 rounded-3xl blur-3xl"></div>
              <div className="relative bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-3xl p-3 overflow-hidden">
                <div className="relative">
                  <div className="absolute inset-0 bg-accent-400/10 rounded-2xl blur-2xl"></div>
                  <div className="relative mx-auto w-[220px]">
                    <div className="bg-foreground-900 rounded-[2.5rem] p-2 shadow-2xl">
                      <div className="flex justify-center pb-1.5">
                        <div className="bg-foreground-950 rounded-full w-16 h-4 flex items-center justify-center gap-0.5">
                          <div className="w-1.5 h-1.5 rounded-full bg-foreground-800"></div>
                        </div>
                      </div>
                      <div className="rounded-[2rem] overflow-hidden bg-background-50 flex flex-col">
                        <div className="bg-background-50 px-4 pt-1.5 pb-0.5 flex items-center justify-between">
                          <span className="text-[10px] font-semibold text-foreground-700">
                            9:41
                          </span>
                          <div className="flex items-center gap-1">
                            <span className="w-3 h-3 flex items-center justify-center text-foreground-500">
                              <i className="ri-signal-wifi-line text-[8px]"></i>
                            </span>
                            <span className="w-3 h-3 flex items-center justify-center text-foreground-500">
                              <i className="ri-battery-2-line text-[8px]"></i>
                            </span>
                          </div>
                        </div>
                        <div className="bg-primary-500 px-4 py-2">
                          <p className="text-[10px] font-semibold text-background-50 text-center">
                            Quick Prosthetics
                          </p>
                        </div>
                        <div className="px-4 py-3 flex flex-col gap-2.5">
                          <p className="text-[10px] text-foreground-500 leading-relaxed">
                            Free for amputees. We handle the paperwork,
                            insurance, and financing. Works with any clinic or
                            finds you one.
                          </p>
                          <div className="bg-primary-50 rounded-lg p-2.5">
                            <p className="text-[10px] font-semibold text-foreground-950 mb-1">
                              Welcome to Quick Prosthetics
                            </p>
                            <p className="text-[8px] text-foreground-500 mb-2">
                              To get started, are you completing this for
                              yourself?
                            </p>
                            <div className="space-y-1.5">
                              <div className="bg-background-50 border border-background-200 rounded-md px-2.5 py-2 text-[9px] font-medium text-foreground-700">
                                Yes, I am the amputee
                              </div>
                              <div className="rounded-md px-2.5 py-2 text-[9px] font-medium bg-primary-500 text-background-50">
                                No, I am helping a loved one
                              </div>
                            </div>
                          </div>
                          <div className="flex items-center gap-2 mt-1">
                            <span className="text-[7px] font-semibold text-foreground-400">
                              Step 1 of 5
                            </span>
                            <div className="flex-1 h-1 bg-background-200 rounded-full overflow-hidden">
                              <div className="h-full bg-primary-500 rounded-full w-[20%]" />
                            </div>
                            <span className="text-[7px] font-bold text-foreground-400">
                              20%
                            </span>
                          </div>
                          <div className="flex justify-center pt-1 pb-2">
                            <div className="w-20 h-1 bg-foreground-300 rounded-full"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="absolute bottom-3 left-3 right-3 bg-background-50/90 backdrop-blur-md rounded-xl px-4 py-3 border border-background-200/50">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-hand-heart-line text-accent-600 text-sm"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-600">
                        Find a prosthetist or keep yours —
                      </p>
                      <p className="text-sm font-semibold text-foreground-950">
                        either way, it's completely free
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <a
        href="#how-it-works"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 cursor-pointer group"
      >
        <span className="text-background-50/60 text-xs font-medium tracking-wider uppercase group-hover:text-background-50/90 transition-colors">
          Scroll to explore
        </span>
        <span className="w-5 h-5 flex items-center justify-center animate-bounce">
          <i className="ri-arrow-down-line text-background-50/80 text-lg group-hover:text-background-50 transition-colors"></i>
        </span>
      </a>
    </section>
  );
}
